var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMediaFilled = function SvgMediaFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 5.75A3.75 3.75 0 0 1 5.75 2h6.5A3.75 3.75 0 0 1 16 5.75V8h2.25A3.75 3.75 0 0 1 22 11.75v6.5A3.75 3.75 0 0 1 18.25 22h-6.5A3.75 3.75 0 0 1 8 18.25V16H5.75A3.75 3.75 0 0 1 2 12.25zM14.5 8V5.75a2.25 2.25 0 0 0-2.25-2.25h-6.5A2.25 2.25 0 0 0 3.5 5.75v4.991l.43-.282a3.75 3.75 0 0 1 4.136.017l.127.084A3.75 3.75 0 0 1 11.75 8zM5 6.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m8.39 6.292a.75.75 0 0 1 .766.027l2.8 1.8a.75.75 0 0 1 0 1.262l-2.8 1.8A.75.75 0 0 1 13 16.8v-3.6a.75.75 0 0 1 .39-.658",
    clipRule: "evenodd"
  })));
};
export default SvgMediaFilled;